import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'

/**
 * Hook that determines whether properties should be hidden based on user type and feature flags.
 * Returns true when the user is a virtual marketer and native property columns are enabled.
 */
export const useHideProperties = (): boolean => {
  const isVirtualMarketer = useIsVirtualMarketer()
  const nativePropertyColumnsEnabled = useFlipperFlag('use_native_property_columns')

  return !!isVirtualMarketer && !!nativePropertyColumnsEnabled
}
